import PropTypes from "prop-types";
import styles from "./CloseButton.module.css";
import classNames from "classnames";

/**
 * Interactive component. A button that closes a feed modal when clicked..
 */
export function CloseButton({ onClick, color, backgroundColor, border }) {
  return (
    <div className={styles.container} onClick={onClick}>
      <span
        className={classNames(
          styles.button,
          border === true ? styles.withBorder : styles.noBorder
        )}
        style={{
          color: color,
          backgroundColor: backgroundColor,
        }}
      >
        &times;
      </span>
    </div>
  );
}

CloseButton.propTypes = {
  /**
   * The function that fires when button is clicked.
   */
  onClick: PropTypes.func,
  /**
   * Decides the color of the X
   */
  color: PropTypes.string,
  /**
   * Changes the background color
   */
  backgroundColor: PropTypes.string,
  /**
   * Decides if there is a border or not
   */
  border: PropTypes.bool,
};
